import { periodsMap } from '../../constants';

const getPeriodElements = (periods, isDisabled, t, prefix = '') =>
  periods.map((key) => ({
    label: t(`${prefix}${periodsMap[key].label}`),
    value: key,
    disabled: isDisabled
  }));

export default getPeriodElements;
